import React from 'react'
import { GetServerSideProps } from 'next'
import { LoginPage } from '../features/LoginPage'
import { getServerSession } from '../utils/auth'
import { getPageTitle } from '../utils/pageTitle'

const Login = () => <LoginPage />

Login.pageSettings = {
  title: getPageTitle('Sign In'),
  pageName: 'login',
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  // If user is already logged in, redirect to home or returnTo
  const session = await getServerSession(ctx)

  if (session) {
    const returnTo = (ctx.query.returnTo as string) || '/'
    return {
      redirect: {
        destination: returnTo,
        permanent: false,
      },
    }
  }

  return {
    props: {},
  }
}

export default Login
